import { NotificationManager } from 'react-notifications';
import axios from 'axios'

axios.defaults.headers['Pragma'] = 'no-cache';

const pingEventService = () => {
  return new Promise((resolve) => {

    axios.bind(pingServiceToOLB(Event));
  })
}

const ApiRequestor = (options, pendingActionType, suceessActionType, failureActionType) => {
  return dispatch => {
    dispatch({ type: pendingActionType });
    return new Promise(() => {

      pingServiceToOLB(Event)

      axios({
        ...options,
        headers: { ...options.headers }
      })
        .then(response => {
          dispatch({ type: suceessActionType, data: response.data });
        })
        .catch(() => {
          NotificationManager.error('unable to process');
          dispatch({ type: failureActionType });
        });
    });
  };
};

export {
  pingEventService
}
export default ApiRequestor;

//END OLB PING INCOMING (extend session)
function pingServiceToOLB(Event) {
  handlePingService(Event); 
    //return
}

function handlePingService(Event) {

  var _event = new Event(Event);

  _event = {
      name: 'END_OLB_PING_INCOMING',
  };

//Post END Ping Event for OLB to extend session
  window.parent.postMessage(_event, '*')
  console.log('END Ping Event Created')

  //END SETTING HEIGHT Height
  handleiFrameHeight(Event)
}


function handleiFrameHeight(Event) {
     
    // var root = document.getElementById('root');
    // //var target = root.innerHTML.height;
    // //var target = root.clientHeight;
    // //var target = window.innerHeight;
   
    // var _event = new Event(Event);
   
//     _event = {
//         name: 'END_SETTING_HEIGHT',
//         //height: root._owner.clientHeight
//         height: root.parentElement.parentElement.offsetHeight
//     };

// //Post END Height Event for OLB 
//   window.parent.postMessage(_event, '*')
  console.log('END Height Event Created')
}





